import { Control, Controller, useWatch } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Input } from 'antd';
import { getProductListNew, PmsProductEs } from 'apis/pms';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';

const ProductDescription = ({
  control,
  productId,
}: {
  control: Control<CreateProductFormSchemaType>;
  productId?: number;
}) => {
  const oldProductSn = useWatch({ control, name: 'description' });

  const [sameOldProductSnProductList, setSameOldProductSnProductList] =
    useState<PmsProductEs[]>([]);
  useEffect(() => {
    if (oldProductSn) {
      getProductListNew({
        pageNum: 1,
        pageSize: 100,
        oldProductSn,
      }).then((res) => {
        if (!productId) {
          setSameOldProductSnProductList(res.list);
        } else {
          setSameOldProductSnProductList(
            res.list.filter((i) => {
              return i.id !== Number(productId);
            })
          );
        }
      });
    } else {
      setSameOldProductSnProductList([]);
    }
  }, [oldProductSn, productId]);

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <FormLabel>{i18n.t(LOCALS.SYLYoWTeQq)}:</FormLabel>
        <Controller
          name="description"
          control={control}
          render={({ field }) => (
            <Input.TextArea
              {...field}
              rows={4}
              placeholder={i18n.t(LOCALS.zYZFfigLSj) || ''}
            />
          )}
        />
      </div>
      {!!sameOldProductSnProductList.length && (
        <div className="flex gap-2">
          <FormLabel className="text-red-500">
            <Trans i18nKey={LOCALS.AdcTXGDchO} />:
          </FormLabel>
          <div>
            {sameOldProductSnProductList.map((i) => {
              return (
                <div key={i.id}>
                  <a
                    href={`/pms/product-edit/${i.id}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {i.name}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDescription;
